import { setVisitTime } from '../utils/helpers'

const startVisitListener = (id) => {
    return Echo.private('start_visit.' + id)
        .listen('StartVisit', (e) => {
            console.log(e)
            let visit = e.visit
            setVisitTime(new Date(visit.start_time).getTime())
            //$('#start-visit').removeClass('fa-minus-square-o').addClass('fa-plus-square-o')

            $('.start-stop-visit').removeClass('disabled')
            let visitor_box = $('#visitor-box')
            let visitor_type = visitor_box.data('visitorType')
            let visitor_id = visitor_box.data('visitorId')
            let profileTab = $('#profile-tab');
            if (visitor_type === visit.visitor_type && visitor_id === visit.visitor_id) {
                $('.visit-time-lbl').removeClass('hide')
                $('.start-visit-lbl').text("Stop visit")
                $('.visit-id').val(visit.id)
            } else {
                visitor_box.addClass('display-none')
                $('#cannot-start').removeClass('display-none')
                if (profileTab.length) {
                    profileTab.trigger('click');
                }
            }
            $.ajax({
                url: window.location.origin + '/admin/user/' + e.user_id + '/active-visitor',
                type: 'GET',
                success: function (result) {
                    $('.active-visitor').html(result)
                },
                error: function (result) {
                    new Noty({
                        type: "warning",
                        text: 'Something happened',
                    }).show()
                }
            })
            new Noty({
                text: "Visit started: Please be aware you need to stop the visit when your meeting is finished!",
                type: "success"
            }).show()
        })
        .listen('SchoolFeedbackVisit', (e) => {
            $('#feedback-visitor-id').val(e.visitor_id);
            $('#feedback-visitor-phone').val(e.visitor_phone);
            $('#feedback-visitor-name').val(e.visitor_name);
            $('#feedback-visitor-type').val(e.visitor_type);
            $('#feedback-user-branch').val(e.user_branch);
            $.ajax({
                url: window.location.origin + '/admin/schools-by-country/' + e.country_id,
                type: 'GET',
                success: function (result) {
                    let $schoolSelect = $('#feedback-visitor-schools');
                    $schoolSelect.append($('<option />').val('').text('Select School'));
                    $.each(result, function(key, name) {
                        $schoolSelect.append($('<option />').val(key).text(name));
                    });
                    $schoolSelect.select2({'width':'100%'})
                },
                error: function (result) {
                    new Noty({
                        type: "warning",
                        text: 'Something happened',
                    }).show()
                }
            })
            $('.overlay-school-feedback').show();
        })
        .error((error) => {
            handleError('start_visit', id, error)
        })
}

const endVisitListener = (id) => {
    return Echo.private('end_visit.' + id)
        .listen('EndVisit', (e) => {
            let visit = e.visit_id
            $('#cannot-start').hide()
            $('#visitor-box').removeClass('display-none')
            $('.visit-time-lbl').addClass('hide')
            $('.start-visit-lbl').text("Start visit")
            $('.active-visitor').hide()
            $('.start-stop-visit').removeClass('disabled')
        })
        .error((error) => {
            handleError('end_visit', id, error)
        })
}

const handleError = (channel, id, error) => {
    console.error("Error details:", error);
    console.error(`Echo error at channel ${channel}.${id}`);
}

export { startVisitListener, endVisitListener }